import './project.css';
import Navbar from "../Navbar/Navbar";

// import "react-image-gallery/styles/css/image-gallery.css";
// import ReactImageGallery from "react-image-gallery";

import { useContext, useEffect, useState } from 'react';
import { GlobalState } from '../../globalState';
import { useParams } from 'react-router-dom';
import i18n from '../../i18n';
import { useTranslation } from 'react-i18next';
import Loading from '../../utils/loading/Loading';

export default function Project() {
    const state = useContext(GlobalState);
    const [detailProject, setDetailProject] = useState(null);
    const [detailProjectPersian, setDetailProjectPersian] = useState(null);
    const [detailProjectArabic, setDetailProjectArabic] = useState(null);
    const params = useParams();
    const [projects] = state.projectsAPI.project;
    const {t} = useTranslation()
    
    useEffect(() => {
        const savedLanguage = localStorage.getItem('language') || 'en';
        i18n.changeLanguage(savedLanguage);
        const rootElement = document.getElementById('root');
        if (savedLanguage === 'fa' || savedLanguage === 'ar') {
          rootElement.classList.remove('ltr', 'text-left');
          rootElement.classList.add('rtl', 'text-right');
        } else {
          rootElement.classList.remove('rtl', 'text-right');
          rootElement.classList.add('ltr', 'text-left');
        }
      }, []);

      const [currentIndex, setCurrentIndex] = useState(0);
      const [isFullscreen, setIsFullscreen] = useState(false);


      const handleThumbnailClick = (index) => {
        setCurrentIndex(index);
      };

      const toggleFullscreen = () => {
    setIsFullscreen(!isFullscreen);
  };


      useEffect(() => {
        const handleFullscreenChange = () => {
          const isFullscreen = document.fullscreenElement !== null;
          const thumbnailsContainer = document.querySelector(".image-gallery-thumbnails-container");
          
          if (isFullscreen && thumbnailsContainer) {
            thumbnailsContainer.style.display = "grid";
            thumbnailsContainer.style.gridTemplateColumns = "repeat(10, 1fr)";
            thumbnailsContainer.style.gridAutoRows = "auto";
            thumbnailsContainer.style.gap = "1px";
          } else if (thumbnailsContainer) {
            thumbnailsContainer.style.display = "flex"; // Revert to default
            thumbnailsContainer.style.gridTemplateColumns = "unset";
            thumbnailsContainer.style.gridAutoRows = "unset";
            thumbnailsContainer.style.gap = "unset";
          }
        };
    
        document.addEventListener("fullscreenchange", handleFullscreenChange);
        return () => document.removeEventListener("fullscreenchange", handleFullscreenChange);
      }, []);
      
    useEffect(() => {
        let projectsArray = [];
        if (Array.isArray(projects)) {
            projectsArray = projects;
        } else if (projects && typeof projects === 'object') {
            projectsArray = Object.values(projects);
        } else {
            console.error("projects is not an array and cannot be transformed", projects);
        }

        if (params.id) {
            projectsArray.forEach(project => {
                if (project._id === params.id){
                  setDetailProject(project);
                  setDetailProjectPersian(project);
                  setDetailProjectArabic(project);
                } 
                    
            });
        }
    }, [params.id, projects]);

    if (!detailProject) return <div><Loading /></div>;

    const images = detailProject.images.map(imagePath => ({
        original: imagePath,
        thumbnail: imagePath,
    }));

    return (
        <>
            <div className=' mb-10 w-[100%] flex flex-col justify-center m-auto '>
            <header className="sticky top-0 z-50 flex justify-center mt-2 items-center w-[100%]">
              <div className="m-auto w-[99%] ltr">
                <Navbar />
              </div>
            </header>
                <div className='mt-[80px] w-[99%] flex flex-col laptop:w-[100%] desktop:w-[80%] desktopXL:w-[80%] desktop:flex-row tablet:justify-between items-start m-auto '>
                        {/* Details */}
                    <div className=''>
                    {
                        i18n.language === 'en' ? <div className=" bgBlurDetail2 border border-slate-400 font-serif flex flex-col justify-center items-center  laptop:w-4/6  desktop:w-[550px] desktopXL:w-[650px] m-auto p-2 mt-1 mb-3 ">
                        <h1 className="font-englishTitle text-3xl uppercase w-[100%] text-center mt-7 mb-14">{detailProject.title}<hr className='bg-gray-900 w-[50%] m-auto' /></h1>
                        <div className=' w-[100%] flex flex-col justify-center items-center '>
                            <div className="flex mb-6 flex-col laptop:flex-row justify-center items-center">
                                <label htmlFor="" className="font-englishTitle mx-2 text-[18px] laptop:text-[22px]">{ t("ProjecetEmplo")}: </label>
                                <p className="font-english text-[18px] laptop:text-[22px] text-gray-700">{detailProject.employe}</p>
                            </div>
                            {/* <div className="flex mt-5 mb-4 flex-col laptop:flex-row justify-center items-center">
                                <label htmlFor="" className="font-englishTitle mx-2 text-[18px] laptop:text-[22px]">{ t("ProjecDesigner")}: </label>
                                <p className="font-english text-[18px] laptop:text-[22px] text-gray-700">{detailProject.designer}</p>
                            </div> */}
                            <p className="font-english p-3 m-2 mb-3 mt-5 text-justify  text-[20px] text-gray-700">{detailProject.desc}</p>
                        </div>
                    </div> : i18n.language === 'fa' ? <div className=" bgBlurDetail2 border border-slate-400 font-serif flex flex-col justify-center items-center  laptop:w-4/6  desktop:w-[550px] desktopXL:w-[650px] m-auto p-2 mt-1 mb-3 ">
                        <h1 className="font-persianTitle text-3xl uppercase w-[100%] text-center mt-7 mb-14">{detailProjectPersian.pTitle}<hr className='bg-gray-900 w-[50%] m-auto' /></h1>
                        <div className=' w-[100%] flex flex-col justify-center items-center '>
                            <div className="flex mb-6 flex-col laptop:flex-row justify-center items-center">
                                <label htmlFor="" className="font-persianTitle mx-2 text-[18px] laptop:text-[22px] ">{ t("ProjecetEmplo")}: </label>
                                <p className="font-persian text-[18px] laptop:text-[22px] text-gray-700">{detailProjectPersian.pEmploye}</p>
                            </div>
                            {/* <div className="flex mt-5 mb-4 flex-col laptop:flex-row justify-center items-center ">
                                <label htmlFor="" className="font-persianTitle mx-2 text-[18px] laptop:text-[22px]">{ t("ProjecDesigner")}: </label>
                                <p className="font-persian text-[18px] laptop:text-[22px] text-gray-700">{detailProjectPersian.pDesigner}</p>
                            </div> */}
                            <p className="font-persian p-3 m-2 mb-3 mt-5 text-justify text-[20px] text-gray-700">{detailProjectPersian.pDesc}</p>
                        </div>
                    </div> : i18n.language === 'ar' ? <div className="bgBlurDetail2 border border-slate-400 font-serif flex flex-col justify-center items-center  laptop:w-4/6  desktop:w-[550px] desktopXL:w-[650px] m-auto p-2 mt-1 mb-3 ">
                        <h1 className="font-persianTitle text-3xl uppercase w-[100%] text-center mt-7 mb-14">{detailProjectArabic.aTitle}<hr className='bg-gray-900 w-[50%] m-auto' /></h1>
                        <div className=' w-[100%] flex flex-col justify-center items-center '>
                            <div className="flex mb-6 flex-col laptop:flex-row justify-center items-center ">
                                <label htmlFor="" className="font-persianTitle mx-2 text-[18px] laptop:text-[22px] ">{ t("ProjecetEmplo")}: </label>
                                <p className="font-persian  text-[18px] laptop:text-[22px] text-gray-700">{detailProjectArabic.aEmploye}</p>
                            </div>
                            {/* <div className="flex mt-5 mb-4 flex-col laptop:flex-row justify-center items-center ">
                                <label htmlFor="" className="font-persianTitle mx-2 text-[18px] laptop:text-[22px]">{ t("ProjecDesigner")}: </label>
                                <p className="font-persian  text-[18px] laptop:text-[22px] text-gray-700">{detailProjectArabic.aDesigner}</p>
                            </div> */}
                            <p className="font-persian  p-3 m-2 mb-3 mt-5 text-justify text-[20px]  text-gray-700">{detailProjectArabic.aDesc}</p>
                        </div>
                    </div> : ''
                    }
                    </div>

                    {/* Gallery */}
                    <div className='rounded-2xl flex justify-end '>
                    <div className={` ${isFullscreen 
                        ? 'fixed inset-0 bg-black z-50 flex flex-col tablet:flex-row items-end justify-end w-full p-4 gap-4' 
                        : 'w-[100%] tablet:w-[100%] desktop:w-[90%] desktopXL:w-[80%] rounded-2xl'}
                        ltr`}>

  {/* بخش عکس اصلی */}
  <div className={`relative 
    ${isFullscreen 
      ? 'h-[60vh] tablet:h-[80vh] desktop:h-[95vh] w-full tablet:w-[80%] desktop:w-[90%]' 
      : 'h-[400px] w-full '} 
    flex items-center justify-center bg-gray-100 rounded-2xl`}>
    
    <img
      src={images[currentIndex].original}
      alt={images[currentIndex].originalAlt}
      className="rounded-2xl h-full w-full "
    />
    
    <button
      onClick={toggleFullscreen}
      className={`absolute bg-transparent text-4xl text-white hover:text-gray-600 transition-all ease-in-out duration-300 rounded-full ${isFullscreen 
          ? ' bottom-6 right-5 ' 
          : ' bottom-6 right-5'}`}>
      {isFullscreen ? '⛶' : '⛶'}
    </button>
  </div>

  {/* بخش thumbnails */}
  <div className={`p-2 
    ${isFullscreen 
      ? 'w-full tablet:w-[10%] h-[150px] tablet:h-[80vh] desktop:h-[95vh] overflow-x-auto tablet:overflow-y-auto flex tablet:flex-col flex-row gap-4 rounded-lg ' 
      : 'w-full  grid grid-cols-5 gap-1'}`}>
  
    {images.map((item, index) => (
      <img
        key={index}
        src={item.thumbnail}
        alt={item.originalAlt}
        onClick={() => handleThumbnailClick(index)}
        className={`cursor-pointer rounded-lg 
          ${isFullscreen ? 'h-[100px] w-[100px] tablet:h-[100px] tablet:w-full object-cover' : ''} 
          ${index === currentIndex ? 'border-2 border-blue-500 ' : ''}`}
      />
    ))}
  </div>

</div>

                    </div>
                </div>
            </div>
        </>
    );
}
